// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1W9qd","info":"Note_info__1zefJ","note":"Note_note__3J9ie","actions":"Note_actions__Tce4W"};